import fondo from '../img/fond.webp';
import '../css/paginasClientes.css'
import foto from '../img/elsapito.jpg'



const ElsaDommarco = () => {
  return (
    <div className='paginasContainer' id='elsaDommarco'>
       <img src={fondo} className='fondoPaginas' alt='fondo'/>
      <img  className='imgPaginasClientes' src={foto}  alt='elsa dommarco'/>
      <h3>Sitio web desarrollado para Elsa Dommarco</h3>
      <p className='parrafoClientes'>
        Se diseñó y desarrolló un sitio web personalizado para la artista visual Elsa Dommarco, con el objetivo de transmitir la esencia de su obra a través de un entorno digital elegante, funcional y adaptable.

        El proyecto incluyó una estructura responsive optimizada para distintos dispositivos, una interfaz visual limpia que prioriza sus creaciones, y una navegación intuitiva que permite al visitante explorar de manera fluida su universo artístico.

        La página actúa como portafolio profesional, destacando tanto la propuesta estética como conceptual de su trabajo.</p>
      <a className='botonCliente' href='https://dommarcoelsa.com/' target='_blanck'> <button>
    <span>Ver sitio</span>
  </button></a>
    </div>
  )
}

export default ElsaDommarco